import React from "react";
import { Box } from "@mui/material";
import { useParams } from "react-router";
import {
  useLazyGetPodcastQuery,
  useLazyGetPodcastVideoQuery,
} from "../store/api/podcasts";
import { useAuthToken, useRedirectIfNotSubscribed } from "../hooks/auth";
import Header from "../components/videoPodcast/Header";
import PodcastContent from "../components/videoPodcast/PodcastContent";
import BooksContent from "../components/videoPodcast/BooksContent";
import Socials from "../components/home/Socials";
import { useDispatch } from "react-redux";
import {
  setEpisodes,
  setMedia,
  setPodcast as setPodcastInStore,
  setWatchType,
} from "../store/reducers/mediaSlice";

const VideoPodcast = () => {
  useRedirectIfNotSubscribed();
  const params = useParams();

  const slug = React.useMemo(() => {
    return params?.slug;
  }, [params]);

  const [podcast, setPodcast] = React.useState(null);
  const [isDownloadingTranscript, setIsDownloadingTranscript] =
    React.useState(false);
  const [queryGetPodcast] = useLazyGetPodcastQuery();
  const [queryGetPodcastVideo] = useLazyGetPodcastVideoQuery();

  const authToken = useAuthToken();

  React.useEffect(() => {
    // if (!slug) window.location = "/";
    if (!authToken) return () => {};

    queryGetPodcast({ slug })
      .then((result) => {
        setPodcast(result.data);
        // queryGetPodcastVideo({ id: result.data.id, authToken })
        //   .then((result) => {
        //     console.log(result);
        //     setPodcastVideos(result.data);
        //   })
        //   .catch((err) => {
        //     console.log(err);
        //   });
      })
      .catch((err) => {
        console.log(err);
        // window.location = "/";
      });
  }, [slug, authToken]);

  const trailerItem = React.useMemo(() => {
    if (!podcast?.ba) return null;
    return {
      type: "trailer",
      titre: "Bande d'annonce - " + podcast.titre,
      image: `https://medias.inrees.com/img/pro/audiovisuel/home_${podcast?.id}.jpg`,
      videoLink: podcast.ba,
    };
  }, [podcast]);

  const videoItems = React.useMemo(() => {
    if (!podcast) return [];
    return podcast.videos
      .map((video) => {
        return {
          ...video,
          titre: `${video.titre}`,
          type: "episode",
          image: `https://medias.inrees.com/img/pro/audiovisuel/home_${podcast?.id}.jpg`,
          videoLink: null,
        };
      })
      .sort((a, b) => a.ordre - b.ordre);
  }, [podcast]);

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (podcast && videoItems?.length > 0) {
      dispatch(setEpisodes(videoItems));
    }
  }, [podcast, videoItems]);

  const handleWatch = (media) => {
    dispatch(setPodcastInStore(podcast));
    dispatch(setWatchType("watch"));
    dispatch(setMedia(media ?? videoItems[0]));
    dispatch(setEpisodes(videoItems));
  };

  const handleListen = (media) => {
    dispatch(setPodcastInStore(podcast));
    dispatch(setWatchType("listen"));
    dispatch(setMedia(media ?? videoItems[0]));
    dispatch(setEpisodes(videoItems));
  };

  const handleDownloadTranscript = async () => {
    if (!slug || !authToken || isDownloadingTranscript) return;

    try {
      setIsDownloadingTranscript(true);
      const response = await fetch(`/api/v1/podcasts/transcription-pdf/${slug}`, {
        method: "GET",
        headers: {
          authorization: `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to download transcript: ${response.status}`);
      }

      const pdfBlob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(pdfBlob);
      const link = document.createElement("a");
      const filename =
        podcast?.titre
          ?.normalize("NFD")
          ?.replace(/[\u0300-\u036f]/g, "")
          ?.replace(/[^a-zA-Z0-9-_]+/g, "-")
          ?.replace(/-+/g, "-")
          ?.replace(/^-|-$/g, "")
          ?.toLowerCase() || "transcription-podcast";

      link.href = downloadUrl;
      link.download = `${podcast?.id || '0'}_${filename}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error(error);
      window.alert("Le téléchargement de la transcription a échoué.");
    } finally {
      setIsDownloadingTranscript(false);
    }
  };

  if (!podcast || !videoItems || !trailerItem) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Header
        podcast={podcast}
        videoItems={videoItems}
        onClickWatch={handleWatch}
        onClickListen={handleListen}
        onClickDownloadTranscript={handleDownloadTranscript}
        isDownloadingTranscript={isDownloadingTranscript}
      />
      <PodcastContent
        podcast={podcast}
        trailerItem={trailerItem}
        videoItems={videoItems}
        onClickWatch={handleWatch}
        onClickListen={handleListen}
      />
      <BooksContent podcast={podcast} />
      <Socials />
    </Box>
  );
};

export default VideoPodcast;
